import { AbstractControl, ValidatorFn } from '@angular/forms';
import { computeWithoutCheck } from 'iso-7064';

export const validateLEI = (value) => {
    const match = value.match(/^[0-9A-Z]{18}[0-9]{2}$/);

    if (match) {
        return computeWithoutCheck(value) === 1;
    }

    return false;
};

export const lei = (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: boolean } => {
        let v: string = control.value;

        if (!v) {
            return null;
        }

        v = v.toUpperCase().replace(/\s/, '');

        return validateLEI(v) ? null : { lei: true };
    };
};
